import branding from "./branding";
import {
  summariseSubjectPaperResults,
} from "./subjectCatalog";
import "./SubjectSelection.css";

function SubjectSelection({
  language,
  userEmail,
  results,
  onSelect,
  onLogout,
}) {
  const subjectPapers =
    summariseSubjectPaperResults(results);

  return (
    <main className="subject-selection-page">
      <header className="subject-selection-header">
        <div>
          <p className="subject-selection-eyebrow">
            {branding.platformName}
          </p>
          <h1>
            {language === "af"
              ? "Kies jou vak en vraestel"
              : "Choose your subject and paper"}
          </h1>
          <p>
            {language === "af"
              ? `Welkom terug, ${userEmail}`
              : `Welcome back, ${userEmail}`}
          </p>
        </div>

        {onLogout && (
          <button
            type="button"
            className="subject-selection-logout"
            onClick={onLogout}
          >
            {language === "af"
              ? "Teken uit"
              : "Logout"}
          </button>
        )}
      </header>

      <section className="subject-selection-grid">
        {subjectPapers.map((subjectPaper) => {
          if (!subjectPaper.tutorAvailable) {
            return (
              <article
                className="subject-selection-card subject-selection-card-locked"
                key={subjectPaper.paperCode}
              >
                <span className="subject-selection-icon">
                  {subjectPaper.icon}
                </span>
                <span className="subject-selection-card-copy">
                  <strong>
                    {subjectPaper.name[language]}
                  </strong>
                  <small>
                    {subjectPaper.focus[language]}
                  </small>
                </span>
                <span className="subject-selection-access">
                  <span className="subject-selection-status">
                    {language === "af"
                      ? "Word voorberei"
                      : "Coming soon"}
                  </span>
                </span>
              </article>
            );
          }

          return (
            <button
              type="button"
              className="subject-selection-card"
              key={subjectPaper.paperCode}
              onClick={() =>
                onSelect(subjectPaper.paperCode)
              }
            >
              <span className="subject-selection-icon">
                {subjectPaper.icon}
              </span>

              <span className="subject-selection-card-copy">
                <strong>
                  {subjectPaper.name[language]}
                </strong>
                <small>
                  {subjectPaper.focus[language]}
                </small>
              </span>

              <span className="subject-selection-result">
                {subjectPaper.averagePercentage === null ? (
                  <>
                    <strong>—</strong>
                    <small>
                      {language === "af"
                        ? "Geen vraestelle voltooi"
                        : "No papers completed"}
                    </small>
                  </>
                ) : (
                  <>
                    <strong>
                      {subjectPaper.averagePercentage}%
                    </strong>
                    <small>
                      {language === "af"
                        ? `Gemiddeld van ${subjectPaper.completedPapers}`
                        : `Average of ${subjectPaper.completedPapers}`}
                    </small>
                  </>
                )}
              </span>
            </button>
          );
        })}
      </section>
    </main>
  );
}

export default SubjectSelection;
